const STORAGE_KEY = 'optune_pending_upload_cleanup_v1';
const TTL_MS = 30 * 60 * 1000;

function readAll() {
    try {
        const raw = sessionStorage.getItem(STORAGE_KEY);
        if (!raw) return [];
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : [];
    } catch {
        return [];
    }
}

function writeAll(entries) {
    try {
        if (!entries.length) {
            sessionStorage.removeItem(STORAGE_KEY);
        } else {
            sessionStorage.setItem(STORAGE_KEY, JSON.stringify(entries));
        }
    } catch {
        /* ignore quota / private mode */
    }
}

/** @param {{ usecaseId: string, datasetName: string, isBenchmark: boolean }} row */
export function appendPendingUploadCleanup(row) {
    const now = Date.now();
    const entries = readAll().filter((e) => now - (e.ts || 0) < TTL_MS);
    const next = entries.filter(
        (e) =>
            !(
                e.usecaseId === row.usecaseId &&
                e.datasetName === row.datasetName &&
                !!e.isBenchmark === !!row.isBenchmark
            )
    );
    next.push({
        usecaseId: row.usecaseId,
        datasetName: row.datasetName,
        isBenchmark: !!row.isBenchmark,
        ts: now,
    });
    writeAll(next);
}

/** @param {{ usecaseId: string, datasetName: string, isBenchmark: boolean }} row */
export function removePendingUploadCleanup(row) {
    const now = Date.now();
    const entries = readAll().filter((e) => now - (e.ts || 0) < TTL_MS);
    const next = entries.filter(
        (e) =>
            !(
                e.usecaseId === row.usecaseId &&
                e.datasetName === row.datasetName &&
                !!e.isBenchmark === !!row.isBenchmark
            )
    );
    writeAll(next);
}

/** @param {string} usecaseId */
export function readFreshPendingUploadCleanupForUsecase(usecaseId) {
    const now = Date.now();
    return readAll().filter(
        (e) =>
            e.usecaseId === usecaseId &&
            now - (e.ts || 0) < TTL_MS
    );
}

/**
 * All pending-cleanup rows for the usecase, including expired (beyond TTL_MS) entries
 * still present in storage. Used to recover pending-cleanup guards when readFresh is
 * empty but refs still hold a name (long-lived tab) or when another append pruned TTL.
 *
 * @param {string} usecaseId
 */
export function readPendingUploadCleanupRowsForUsecaseAnyAge(usecaseId) {
    if (!usecaseId) return [];
    return readAll().filter((e) => e.usecaseId === usecaseId);
}
